module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgIGZpbGw9IiM5MTkxOTEiPg0KICA8cGF0aA0KICAgIGQ9Ik0xMiw5QTMsMyAwIDAsMCA5LDEyQTMsMyAwIDAsMCAxMiwxNUEzLDMgMCAwLDAgMTUsMTJBMywzIDAgMCwwIDEyLDlNMTIsMTdBNSw1IDAgMCwxIDcsMTJBNSw1IDAgMCwxIDEyLDdBNSw1IDAgMCwxIDE3LDEyQTUsNSAwIDAsMSAxMiwxN00xMiw0LjVDNyw0LjUgMi43Myw3LjYxIDEsMTJDMi43MywxNi4zOSA3LDE5LjUgMTIsMTkuNUMxNywxOS41IDIxLjI3LDE2LjM5IDIzLDEyQzIxLjI3LDcuNjEgMTcsNC41IDEyLDQuNVoiIC8+DQo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/security/eye.svg
// module id = uqy+
// module chunks = 0